import Vue from 'vue'
import API from '@/config/api'
import axios from 'axios'
import { GET_CONSTANTS } from '@/requests/common'
import TokenService from '@/services/tokenService'

const state = {
  loader: false,
  constants: null,
  user: {
    access_token: null,
    refresh_token: null,
    tokenData: null,
    timezone: 'Europe/Moscow',
  }
}

const mutations = {
  setLoader(state, value) {
    state.loader = value
  },
  setConstants(state, payload) {
    state.constants = payload
  },
  setUser(state, { access, refresh }) {
    TokenService.setTokens(access, refresh)
    state.user.refresh_token = refresh
    state.user.access_token = access
    state.user.tokenData = TokenService.parseJwt(access)
  },
}

const actions = {
  LOGIN: async ({ commit }, payload) => {
    try {
      const response = await axios.post(API.auth.login, payload)
      const { data: { access, refresh } } = response
      commit('setUser', { access, refresh })
    } catch (error) {
      Vue.notify({
        type: 'error',
        text: 'Ошибка авторизации.'
      })
      throw( error )
    }
  },
  LOGIN_SESSION: async ({ commit }, payload) => {
    try {
      const response = await axios.post(API.auth.session_id, payload)
      const { data: { access, refresh } } = response
      commit('setUser', { access, refresh })
    } catch (error) {
      Vue.notify({
        type: 'error',
        text: 'Ошибка авторизации по логину и паролю'
      })
    }
  },
  async GET_CONSTANTS({ commit }) {
    try {
      const { data } = await GET_CONSTANTS()
      commit('setConstants', data.constant_groups)
    } catch (error) {
      Vue.notify({
        type: 'error',
        text: 'Ошибка получения констант с сервера'
      })
    }
  },
  async INIT({ state, commit, dispatch }) {
    try {
      const accessToken = state.user.access_token
      const constants = state.constants

      if (!constants) await dispatch('GET_CONSTANTS')
      if (!accessToken) {
        const query = window.location.search
        const params = new URLSearchParams(query)
        const savedTokens = TokenService.getTokens()
        const sid = params.get('session_id')
        const childId = params.get('selected_child_id')

        if (sid) {
          await dispatch('LOGIN_SESSION', { session_id: sid })
          if (childId) commit('setChildId', childId)
        } else if(savedTokens.access && savedTokens.refresh) {
          commit('setUser', { ...savedTokens })
        }
      }

      return state.user
    } catch (error) {
      console.log(error)
      Vue.notify({
        type: 'error',
        text: 'Ошибка авторизации с использованием сессии'
      })
    }
  }
}

export default {
  state,
  actions,
  mutations
}
